const MONTHS_ES = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

export const RENT_PAYMENT_STATUS_LABEL: Record<string, string> = {
  paid: 'Pagado',
  unpaid: 'No pagado',
  partial: 'Pago parcial',
};

export const TENANT_PAYMENT_KIND_LABEL: Record<string, string> = {
  rent: 'Pago de renta',
  deposit: 'Depósito',
};

export function formatRentPeriod(year: number, month: number): string {
  const m = MONTHS_ES[month - 1];
  return m ? `${m} ${year}` : `${month}/${year}`;
}

/** Convierte "2026-03" a "Marzo 2026". */
export function ymToSpanishLabel(yyyyMm: string): string {
  const [ys, ms] = yyyyMm.split('-');
  const y = Number(ys);
  const mo = Number(ms);
  if (!y || !mo) return yyyyMm;
  return formatRentPeriod(y, mo);
}
